'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _style = require('./style.css');

var _icon = require('../../shared/styles/icon.css');

var _hudlUniformUiComponents = require('hudl-uniform-ui-components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright 2013-2015, Hudl
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This source code is licensed under the BSD-style license found in the
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LICENSE file in the root directory of this source tree. An additional grant
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * of patent rights can be found in the PATENTS file in the same directory.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @providesModule Volume
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Volume control which subscribes to the 'volumechange' event which also contains
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * logic for controlling the Mute state
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var volumeOnIcon = 'audio';
var volumeOffIcon = 'audiooff';

var Volume = function (_React$Component) {
  _inherits(Volume, _React$Component);

  function Volume(props, context) {
    _classCallCheck(this, Volume);

    var _this = _possibleConstructorReturn(this, (Volume.__proto__ || Object.getPrototypeOf(Volume)).call(this, props, context));

    _this.state = {
      volumeHover: false
    };

    _this.volumeChange = function (e) {
      e.stopPropagation();
      e.preventDefault();

      if (e.button !== 0) {
        return;
      }

      var volumeBackControl = _this.volumeSlider;
      var percent = (e.pageY - _this.getYPosition(volumeBackControl)) / volumeBackControl.offsetHeight * 100;
      var inverse = 100 - percent;
      inverse = inverse > 100 ? 100 : inverse;
      inverse = inverse < 0 ? 0 : inverse;

      _this.setVolume(inverse / 100);
    };

    _this.volumeRelease = function (e) {
      e.stopPropagation();
      e.preventDefault();
      window.removeEventListener('mousemove', _this.volumeChange);
      window.removeEventListener('mouseup', _this.volumeRelease);
    };

    _this.mouseOver = function () {
      if (_this.props.contextMenuOpen) {
        return;
      }
      clearTimeout(_this.hoverTimeout);
      _this.setState({ volumeHover: true });
    };

    _this.mouseOut = function () {
      clearTimeout(_this.hoverTimeout);
      _this.createTimeout();
    };

    _this.createTimeout = function () {
      _this.hoverTimeout = setTimeout(function () {
        return _this.setState({ volumeHover: false });
      }, 250);
    };

    _this.mouseOver = _this.mouseOver.bind(_this);
    _this.muteOnClick = _this.muteOnClick.bind(_this);
    return _this;
  }

  _createClass(Volume, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return nextState.volumeHover !== this.state.volumeHover || nextProps.muted !== this.props.muted || nextProps.volume !== this.props.volume;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('mousemove', this.volumeChange);
      window.removeEventListener('mouseup', this.volumeRelease);
    }

    /**
     * Globally used to handle adjustments to volume
     * @param {Number} volumeLevel
     */

  }, {
    key: 'setVolume',
    value: function setVolume(volumeLevel) {
      if (this.props.muted && volumeLevel !== 0) {
        this.props.setMute(false);
      } else if (!this.props.muted && volumeLevel === 0) {
        this.props.setMute(true);
      }

      this.props.setVolume(volumeLevel);
    }
  }, {
    key: 'volumeClick',
    value: function volumeClick(e) {
      if (e.button === 0) {
        window.addEventListener('mousemove', this.volumeChange);
        window.addEventListener('mouseup', this.volumeRelease);
      }
    }

    /**
     * Event for dragging the volume slider and adjusting the volume and the presentation
     */


    /**
     * Event that is triggered on the relase of the volume marker
     */

  }, {
    key: 'volumeSeek',


    /**
     * Handles the volume change based on a click event on the volume slider
     */
    value: function volumeSeek(e) {
      e.stopPropagation();
      var volumeBackControl = this.volumeBar.parentNode;
      var percent = (e.pageY - this.getYPosition(volumeBackControl)) / volumeBackControl.offsetHeight * 100;

      var inverse = Math.floor(100 - percent, 100);

      this.setVolume(inverse / 100);
    }
  }, {
    key: 'volumeMove',
    value: function volumeMove() {
      var volumeBackControl = this.volumeBar.parentNode;
      var percent = this.props.volume * 100 / volumeBackControl.offsetHeight * 100;
      percent > 100 ? percent = 100 : percent;

      this.setVolume(percent / 100);
    }

    /**
     * Returns the Y position of the specified DOM element on the page
     */

  }, {
    key: 'getYPosition',
    value: function getYPosition(element) {
      var y = 0;
      var node = element;

      while (node) {
        y += node.offsetTop - node.scrollTop + node.clientTop;
        node = node.offsetParent;
      }

      return y;
    }
  }, {
    key: 'volumeValue',
    value: function volumeValue() {
      return this.props.muted ? 0 : this.props.volume;
    }
  }, {
    key: 'muteOnClick',
    value: function muteOnClick(muted) {
      this.props.setMute(muted);
    }
  }, {
    key: 'muteIconDOM',
    value: function muteIconDOM(muted) {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        {
          'data-qa-id': 'vi-controls-volumeMuteToggle',
          className: _icon.iconStyle,
          onClick: function onClick() {
            return _this2.muteOnClick(!muted);
          }
        },
        _react2.default.createElement(_hudlUniformUiComponents.Icon, { size: 'medium', type: muted ? volumeOffIcon : volumeOnIcon })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      if (this.props.audioDisabled) {
        return null;
      }

      var height = 100 * this.volumeValue() + '%';
      var muteIconDOM = this.muteIconDOM(this.props.muted);
      var opacity = 1;
      var pointerEvents = 'all';

      if (!this.state.volumeHover) {
        opacity = 0;
        pointerEvents = 'none';
      }

      return _react2.default.createElement(
        'div',
        {
          className: _style.soundContainer,
          'data-qa-id': 'vi-controls-volumeContainer',
          onMouseOver: this.mouseOver,
          onMouseOut: this.mouseOut
        },
        muteIconDOM,
        _react2.default.createElement(
          'div',
          {
            className: _style.volumeBoxOverlay,
            style: { pointerEvents: pointerEvents },
            onMouseOver: this.mouseOver
          },
          _react2.default.createElement(
            'div',
            { className: _style.volumeBoxContainer, style: { opacity: opacity } },
            _react2.default.createElement(
              'div',
              {
                ref: function ref(node) {
                  return _this3.volumeSlider = node;
                },
                onClick: function onClick(e) {
                  return _this3.volumeSeek(e);
                },
                className: _style.innerVolumeBox
              },
              _react2.default.createElement(
                'div',
                {
                  ref: function ref(node) {
                    return _this3.volumeBar = node;
                  },
                  className: _style.volumeBar,
                  style: { height: height }
                },
                _react2.default.createElement('div', {
                  'data-qa-id': 'vi-controls-volumeDragSlider',
                  onMouseDown: function onMouseDown(e) {
                    return _this3.volumeClick(e);
                  },
                  className: _style.volumeSlider
                })
              )
            )
          )
        )
      );
    }
  }]);

  return Volume;
}(_react2.default.Component);

Volume.propTypes = {
  contextMenuOpen: _propTypes2.default.bool.isRequired,
  volume: _propTypes2.default.number.isRequired,
  muted: _propTypes2.default.bool.isRequired,
  playerId: _propTypes2.default.string.isRequired,
  setMute: _propTypes2.default.func.isRequired,
  setVolume: _propTypes2.default.func.isRequired,
  audioDisabled: _propTypes2.default.bool
};
Volume.defaultProps = {
  audioDisabled: false
};
exports.default = Volume;
module.exports = exports['default'];